module.exports = __webpack_public_path__ + "img/tarj2-3.fc2d3162.svg";